module.exports = __webpack_public_path__ + "img/icon-product.472a2e57.svg";